/* eslint-disable camelcase */
import React, { Component } from 'react'
import styled from 'styled-components'
import Tabs from 'components/Tabs'
import TariffSubscribeForm from 'components/TariffSubscribeForm'
import Modal from 'components/Modal'
import Logic from './logic'
import Smiley from './assets/ic-aceitar.svg'
import Loading from 'components/Loading'
import {
  isPhone,
  isEmail,
  isContactPhone,
  hasBillingAddress,
  required,
  cepCui,
  hasPaidServices,
  isChecked,
  isNIF,
  notEmptyEmail,
  notEmptyPhone
} from './validations'

import mapValues from 'lodash/mapValues'

import { isArray, omit } from 'lodash'
import { isEnterprise, isSimple, isAdvanced } from 'config'

const translateErrors = {
  first_name: 'Primeiro Nome',
  last_name: 'Último Nome',
  tax_id: 'NIF',
  email: 'Email',
  phone_number: 'Telefone / Telemóvel',
  company_phone_number: 'Telefone / Telemóvel Contacto',
  company_name: 'Nome da empresa',
  company_cae: 'CAE da empresa',
  company_email: 'Email empresa',
  legal_bi: 'BI/CC do Representante legal',
  street: 'Rua',
  door: 'Nº da porta',
  floor: 'Andar',
  postal_code: 'Código postal',
  billing_address: 'Morada de faturação',
  billing_street: 'Rua de faturação',
  billing_door: 'Nº da porta de faturação',
  billing_floor: 'Andar de faturação',
  billing_postal_code: 'Código postal de faturação',
  cpe: 'CPE',
  cui: 'CUI',
  cuicpe: ['CUI', 'CPE']
}

@Logic
class TariffSubscribeModal extends Component {
  constructor () {
    super()
    this.state = {
      index: 0,
      currentTariff: null,
      open: false,
      errorOpened: true,
      showedDisclaimer: true,
      canSub: true
    }

    this.adhereButtons = [
      {
        label: 'cancelar',
        primary: false,
        click: () => this.toggleModal(),
        color: '#006736'
      },
      {
        label: 'seguinte',
        primary: true,
        click: this.adhereActions
      }
    ]
  }

  isFormValid = (validations) => {
    const key = Object.keys(validations)[0]
    const list = validations[key]
    const formBase = this.props.formData[key]

    let invalid = { [key]: {} }
    mapValues(list, (funcs, valueKey) => {
      for (var index = 0; index < funcs.length; index++) {
        let func = funcs[index]
        let doFirst = true
        if (isArray(func)) {
          func = func[0]
          doFirst = false

          if (!func(formBase[valueKey].value, formBase)) {
            break
          }
        }
        if (doFirst) {
          if (formBase[valueKey]) {
            const { result, message } = func(formBase[valueKey].value, formBase)
            if (!result) {
              invalid[key][valueKey] = message
              break
            }
          }
        }
      }
    })

    if (this.props.tariffInfo && key === 'personal') {
      const { subscription_requires_email, subscription_requires_phone } = this.props.tariffInfo.entity
      let emailKey = 'email'
      let phoneKey = 'phone'
      if (isEnterprise) {
        emailKey = 'companyEmail'
        phoneKey = 'companyPhoneNumber'
      }
      if (!subscription_requires_email && !subscription_requires_phone) {
        const phone = this.props.formData.personal[phoneKey]
        const email = this.props.formData.personal[emailKey]

        const emailVal = notEmptyEmail(email.value, phone.value)
        const phoneVal = notEmptyPhone(phone.value, email.value)

        if (!invalid.personal[phoneKey] && !emailVal.result) {
          invalid.personal[emailKey] = emailVal.message
        }
        if (!invalid.personal[emailKey] && !phoneVal.result) {
          invalid.personal[phoneKey] = phoneVal.message
        }
      }
    }
    return { valid: !Object.keys(invalid[key]).length, invalid }
  }

  transformForm = (form) => {
    if (!form) {
      return false
    }

    // mess
    const { personal, billing, electric, gas } = form
    const {
      name: first_name,
      surname: last_name,
      nif: tax_id,
      email,
      phone: phone_number,
      contact,
      companyName,
      companyCae,
      companyPhoneNumber,
      companyEmail,
      legalBi
    } = personal

    const { street, door, floor, district, municipality,
      billingDoor, billingFloor, billingDistrict,
      billingMunicipality, billingStreet,
      directDebit, electronicBilling, billingAddress } = billing
    const { cpe,
      potency: hired_power,
      tariff: time_cycle,
      cycle: price_list_cycle
    } = electric
    const { cui, tier: price_step } = gas
    const { id: price_list } = this.props.tariffInfo

    let gasFields = {
      current_gas_entity: this.props.tariffInfo.entity.id,
      cui: cui.value,
      price_step: price_step.value
    }

    let eletricityFields = {
      current_electricity_entity: this.props.tariffInfo.entity.id,
      hired_power: hired_power.value,
      cpe: cpe.value,
      time_cycle: time_cycle.value,
      price_list_cycle: price_list_cycle.value
    }

    // Subscription source
    let subscription_source
    if (isSimple) {
      subscription_source = 'simple_simulator'
    }

    if (isAdvanced) {
      subscription_source = 'advanced_simulator'
    }

    if (isEnterprise) {
      subscription_source = 'enterprise_simulator'
    }

    const priceListId = this.props.tariffInfo.priceListObject.priceListId

    // Set the personal object to the correct one based on simulator
    let personalObj = {}
    const isEleContract = !!(this.props.tariffInfo && this.props.tariffInfo.pricelistadditionalinfo.electronic_contract)

    if (isEnterprise) {
      personalObj = {
        first_name: first_name.value,
        last_name: last_name.value,
        tax_id: tax_id.value,
        company_name: companyName.value,
        company_cae: companyCae.value,
        company_phone_number: companyPhoneNumber.value,
        company_email: companyEmail.value,
        legal_bi: legalBi.value,
        contact: contact.value,
        email: email.value,
        phone_number: phone_number.value
      }
    } else {
      personalObj = {
        first_name: first_name.value,
        last_name: last_name.value,
        tax_id: tax_id.value,
        email: email.value,
        phone_number: phone_number.value,
        contact: contact.value
      }

      if (isEleContract) {
        personalObj = omit(personalObj, ['tax_id', 'contact'])
      }
    }

    let obj = {
      ...personalObj,
      street: street.value,
      door: door.value,
      floor: floor.value,
      billing_street: billingStreet.value,
      billing_door: billingDoor.value,
      billing_floor: billingFloor.value,
      billing_detail: `${electronicBilling.value === 'false' ? '' : electronicBilling.value}${directDebit.value === 'false' ? '' : directDebit.value}`,
      billing_address: billingAddress.value,
      billing_district: billingDistrict.value,
      billing_municipality: billingMunicipality.value,
      contract_summary: {},
      price_list: price_list,
      user: '',
      district: district.value,
      municipality: municipality.value,
      subscription_source,
      simulation_price_list: priceListId
    }

    if (this.state.currentTariff.electricityPriceList) {
      obj = { ...obj, ...eletricityFields }
    }

    if (this.state.currentTariff.gasPriceList) {
      obj = { ...obj, ...gasFields }
    }

    return obj
  }

  adhereActions = () => {
    let maxTabs = this.state.tabs.length - 1
    let valid = true
    let invalid
    // if (this.state.currentTariff.electricityPriceList && this.state.currentTariff.gasPriceList) {
    //   maxTabs = 4
    // }

    // if (isSimple) {
    //   maxTabs = 2
    // }

    if (this.state.index <= maxTabs) {
      const validation = this.isFormValid(this.validations[this.state.index])
      valid = validation.valid
      invalid = validation.invalid
    }

    if (valid) {
      this.actions.recheckValids()
      if (this.state.index < maxTabs) {
        this.tabChange(this.state.index + 1)
      } else {
        this.actions.submitForm(this.transformForm(this.props.formData))
      }
    } else {
      this.actions.setInvalid(invalid)
    }
  }

  tabChange = (index) => {
    let valid = true
    let invalid
    if (index > this.state.index) {
      const validation = this.isFormValid(this.validations[this.state.index])
      valid = validation.valid
      invalid = validation.invalid
    }

    if (valid) {
      if (index === this.state.tabs.length - 1) {
        this.adhereButtons = [
          {
            label: 'anterior',
            primary: false,
            click: () => this.state.index > 0 && this.tabChange(this.state.index - 1),
            color: '#006736'
          },
          {
            label: 'Aderir',
            primary: true,
            click: this.adhereActions
          }
        ]
      } else if (index === 0) {
        this.adhereButtons = [
          {
            label: 'seguinte',
            primary: true,
            click: this.adhereActions
          }
        ]
      } else {
        this.adhereButtons = [
          {
            label: 'anterior',
            primary: false,
            click: () => this.state.index > 0 && this.tabChange(this.state.index - 1),
            color: '#006736'
          },
          {
            label: 'seguinte',
            primary: true,
            click: this.adhereActions
          }
        ]
      }
      this.setState({ index })
    } else {
      this.actions.setInvalid(invalid)
    }
  }

  toggleModal = (open = false) => {
    this.setState({ open }, () => !this.state.opened && this.actions.reset() && this.props.changeTariff(null))
  }

  toggleErrorModal = () => {
    this.actions.setAdhesionError(null)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      currentTariff: nextProps.tariff
    })

    if (nextProps.tariffInfo) {
      const { tariff, values: {
          potencia_contratada,
          ciclo_tarifa,
          municipality
        },
        simulation
      } = nextProps
      const {
        priceListTimeCycle
      } = this.props.tariff
      const { subscription_requires_email, subscription_requires_phone } = nextProps.tariffInfo.entity
      const isEleContract = nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract
      isEleContract && this.setState({ tabs: ['Dados Pessoais', 'Confirmação'] })

      if (nextProps.firstSet && isEleContract) {
        if (tariff.suggested_electricity) {
          if (potencia_contratada) {
            this.changeField('electric', 'potency', potencia_contratada)
          }
          if (ciclo_tarifa) {
            this.changeField('electric', 'cycle', ciclo_tarifa)
          }
          if (priceListTimeCycle) {
            this.changeField('electric', 'tariff', priceListTimeCycle)
          }
        }

        if (simulation.gasStage) {
          this.changeField('gas', 'tier', simulation.gasStage)
        }

        if (municipality) {
          this.changeField('billing', 'municipality', municipality)
        }

        if (this.validations) {
          delete this.validations[0].personal.nif
          this.validations = this.validations.filter(val =>
            !Object.keys(val).find(k => (k === 'billing' || k === 'electric' || k === 'gas')))
        }
        this.actions.setFirstSet(false)
      }

      if (this.validations) {
        let emailKey = 'email'
        let phoneKey = 'phone'
        const phone = this.validations[0].personal[phoneKey]
        const email = this.validations[0].personal[emailKey]

        if (subscription_requires_email && !email.length) {
          this.validations[0].personal[emailKey].push(...[required, isEmail])
        }
        if (subscription_requires_phone && !phone.length) {
          this.validations[0].personal[phoneKey].push(...[required, isPhone])
        }
      }
    }
  }

  hideDisclaimer = () => {
    this.adhereButtons = [
      {
        label: 'cancelar',
        primary: false,
        click: () => this.toggleModal(),
        color: '#006736'
      },
      {
        label: 'seguinte',
        primary: true,
        click: this.adhereActions
      }
    ]
    this.setState({ showedDisclaimer: true })
  }

  componentWillMount () {
    const { tariff, values: {
        potencia_contratada,
        ciclo_tarifa,
        cae
      },
      simulation,
      tariffInfo
    } = this.props
    const {
      priceListTimeCycle
    } = this.props.tariff

    let gasOrEletricity = []
    let eleSub = true
    let gasSub = true
    const isEleContract = !!tariffInfo && tariffInfo.pricelistadditionalinfo.electronic_contract

    if (tariff.electricityPriceList) {
      const { electricityPriceList: { entity: { can_subscribe: canSub } } } = tariff
      eleSub = canSub
    }
    if (tariff.gasPriceList) {
      const { gasPriceList: { entity: { can_subscribe: canSub } } } = tariff
      gasSub = canSub
    }
    if (!eleSub || !gasSub) {
      this.adhereButtons = [
        {
          label: 'Fechar',
          primary: true,
          click: () => this.toggleModal()
        }
      ]
      this.setState({ currentTariff: tariff, canSub: false, showedDisclaimer: true })
    } else {
      if (tariff.electricityPriceList) {
        !isEleContract && !isSimple && gasOrEletricity.push('Fornecimento Eletricidade')
        if (potencia_contratada) {
          this.changeField('electric', 'potency', potencia_contratada)
        }
        if (ciclo_tarifa) {
          this.changeField('electric', 'cycle', ciclo_tarifa)
        }
        if (priceListTimeCycle) {
          this.changeField('electric', 'tariff', priceListTimeCycle)
        }
      }

      if (tariff.gasPriceList) {
        !isEleContract && !isSimple && gasOrEletricity.push('Fornecimento Gás Natural')

        if (simulation.gasStage) {
          this.changeField('gas', 'tier', simulation.gasStage)
        }
      }

      if (isEnterprise) {
        this.changeField('personal', 'companyCae', cae)
      }

      const billing = []
      if (!isEleContract) {
        billing.push('Faturação')
      }

      const tabs = [
        isEnterprise ? 'Dados Empresariais' : 'Dados Pessoais',
        ...billing,
        ...gasOrEletricity,
        'Confirmação'
      ]

      let personalValidations = {}
      if (isEnterprise) {
        personalValidations = {
          name: [
            required
          ],

          surname: [
            required
          ],

          nif: [
            required,
            isNIF
          ],

          email: [
            isEmail
          ],

          phone: [
            isPhone
          ],

          companyName: [
            required
          ],

          companyCae: [
            required
          ],

          companyPhoneNumber: [
            required
          ],

          companyEmail: [
            isEmail
          ],

          legalBi: [
            required
          ],

          contact: [
            required
          ],

          contact_time: [
            [isContactPhone],
            required
          ]
        }
      } else {
        personalValidations = {
          name: [
            required
          ],

          surname: [
            required
          ],

          nif: [
            required,
            isNIF
          ],

          /*
          * these validations are added later now that
          * entities can control if email or phone are required
          */
          email: [],
          phone: [],

          contact: [
            required
          ],

          contact_time: [
            [isContactPhone],
            required
          ]
        }
      }

      this.validations = [
        { personal: personalValidations }
      ]

      if (!isEleContract) {
        this.validations.push({
          billing: {
            postalCode: [
              required
            ],
            postalExtension: [
              required
            ],
            street: [
              required
            ],
            door: [
              required
            ],
            district: [
              required
            ],
            municipality: [
              required
            ],
            billingPostalCode: [
            [hasBillingAddress],
              required
            ],
            billingPostalExtension: [
            [hasBillingAddress],
              required
            ],
            billingStreet: [
            [hasBillingAddress],
              required
            ],
            billingDoor: [
            [hasBillingAddress],
              required
            ],
            billingDistrict: [
            [hasBillingAddress],
              required
            ],
            billingMunicipality: [
            [hasBillingAddress],
              required
            ]
          }
        })
      }

      if (isEleContract) {
        delete this.validations[0].personal.nif
      }

      if (tariff.electricityPriceList && !isEleContract && !isSimple) {
        this.validations.push({ electric: {
          cpe: [
            required,
            cepCui
          ],
          potency: [
            required
          ],
          tariff: [
            required
          ],
          cycle: [
            required
          ]
        }})
      }

      if (tariff.gasPriceList && !isEleContract && !isSimple) {
        this.validations.push({ gas: {
          cui: [
            required,
            cepCui
          ],
          tier: [
            required
          ]
        }})
      }

      this.validations.push({
        confirm: {
          allowDataSharing: [
            isChecked
          ]
        }
      })

      this.setState({ currentTariff: tariff, tabs })
    }
  }

  componentWillUnmount () {
    this.setState({ index: 0, currentTariff: null })
    this.actions.setTariffInfo(null)
  }

  changeField = (key, property, value) => {
    const section = Object.assign({}, this.props.formData[key])
    const field = Object.assign({}, section[property], { value })
    const data = Object.assign(this.props.formData, { [key]: { ...section, [property]: field } })
    if (property === 'district' || property === 'billingDistrict') {
      this.actions.fetchMunicipalitiesTrigger(value, property)
    }
    this.actions.setFormData(data)
  }

  getPostal = ({ code, ext, type }) => {
    this.actions.fetchPostalInfo(code, ext, type)
  }

  errorsList (errors) {
    return Object.keys(errors).map(key => {
      let field
      if (key === 'cuicpe') {
        field = <div key={key}>Estes {translateErrors[key][0]} e {translateErrors[key][1]} aderiram a um tarifário recentemente. Tem de aguardar 30 dias para efetuar uma nova adesão no Poupa Energia. Se tiver dúvidas ligue-nos para o 211 160 500.</div>
      } else if (key === 'cui' || key === 'cpe') {
        field = <div key={key}>Este {translateErrors[key]} aderiu a um tarifário recentemente. Tem de aguardar 30 dias para efetuar uma nova adesão no Poupa Energia. Se tiver dúvidas ligue-nos para o 211 160 500.</div>
      } else {
        field = <div key={key}>O campo {translateErrors[key]} contém erros.</div>
      }
      return field
    })
  }

  render () {
    if (this.props.adhesionResponse) {
      this.adhereButtons = [
        {
          label: 'fechar',
          primary: false,
          click: () => this.toggleModal(),
          color: '#006736'
        }
      ]
    }

    const { translations, userProfile } = this.props
    const { SUCCESS_SUBSCRIPTION_EMAIL, SUCCESS_SUBSCRIPTION_MERCHANT } = translations || {}

    let designation
    if (this.state.currentTariff && this.state.currentTariff.c) {
      designation = this.state.currentTariff.electricityPriceList.designation
    }
    if (this.state.currentTariff && this.state.currentTariff.gasPriceList) {
      designation = this.state.currentTariff.gasPriceList.designation
    }

    return (
      this.state.currentTariff && this.state &&
      <ScrollModal
        title='adesão ao tarifário:'
        subtitle={designation}
        toggle={this.state.open}
        onClick={this.toggleModal}
        custom={false}
        buttons={this.adhereButtons}
        closeOnBackground={false}
      >
        {!this.props.adhesionResponse &&
        this.state.showedDisclaimer &&
        this.state.canSub &&
        this.props.tariffInfo &&
        <div>
          <Tabs
            tabs={this.state.tabs}
            onClick={this.tabChange}
            hasProgress
            currentIndex={this.state.index}
          />
          <TariffSubscribeForm
            userProfile={userProfile}
            postalInfo={this.props.postalInfo}
            getPostal={this.getPostal}
            municipality={this.props.municipality}
            index={this.state.index}
            tariff={this.state.currentTariff}
            fetchPostalInfo={this.actions.fetchPostalInfo}
            tariffInfo={this.props.tariffInfo}
            electricEntities={this.props.electricEntities}
            gasEntities={this.props.gasEntities}
            onChange={this.changeField}
            hasEletricity={this.props.tariff.electricityPriceList}
            hasGas={this.props.tariff.gasPriceList}
            numberOfTabs={this.state.tabs.length}
            formData={this.props.formData}
            filters={this.props.values}
            districts={this.props.districts}
            municipalities={this.props.municipalities}
            billingMunicipalities={this.props.billingMunicipalities}
            caes={this.props.data && this.props.data.caes}
            loadingAddress={this.props.loadingAddress}
            addressNotFound={this.props.addressNotFound}
            isSimple={isSimple}
          />
        </div>
        }
        {this.props.adhesionResponse && this.state.showedDisclaimer &&
        <SuccessMessage>
          <img alt='' src={Smiley} />
          <SuccessTitle>
            Pré-adesão <span>{this.props.adhesionResponse.code}</span> submetida com sucesso
          </SuccessTitle>
          <SuccessInfo>
          {SUCCESS_SUBSCRIPTION_MERCHANT}
            {!isEnterprise && this.props.formData.personal.email.value &&
            <span>{SUCCESS_SUBSCRIPTION_EMAIL} {this.props.formData.personal.email.value}</span>}
            {isEnterprise && this.props.formData.personal.companyEmail.value &&
            <span>{SUCCESS_SUBSCRIPTION_EMAIL} {this.props.formData.personal.companyEmail.value}</span>}
          </SuccessInfo>
        </SuccessMessage>
        }

        {this.props.adhesionError &&
        <ErrorModal
          title='Aviso'
          toggle={this.state.errorOpened}
          onClick={this.toggleErrorModal}
          custom={false}
        >
          {this.props.adhesionError &&
            this.props.adhesionError.response.data &&
            !(typeof this.props.adhesionError.response.data === 'string') &&
            this.errorsList(this.props.adhesionError.response.data)
          }
          {this.props.adhesionError &&
            this.props.adhesionError.response.data &&
            (typeof this.props.adhesionError.response.data === 'string') &&
            <span>Ocorreu um erro</span>
          }
        </ErrorModal>}

        {!this.state.showedDisclaimer &&
        <Disclaimer>
          <DisclaimerTitle>Esclarecimento</DisclaimerTitle>
          {this.props.tariffInfo && hasPaidServices(this.props.tariffInfo.additional_services) &&
          <DisclaimerText red>
          Este tarifário apresenta fidelização e/ou serviços com custos adicionais
          </DisclaimerText>}
          <DisclaimerText>
            <ListBall />
            Os valores apresentados baseiam-se nos dados introduzidos e representam uma estimativa da sua fatura de energia para os próximos 12 meses e da poupança expectável face ao seu tarifário atual.
          </DisclaimerText>
          <DisclaimerText>
            <ListBall />
            Estes valores têm em consideração as condições de consumo de eletricidade e/ou gás natural inseridos e que se assumem corretos e atuais.
          </DisclaimerText>
          <DisclaimerText>
            <ListBall />
            O presente pedido de adesão não constitui uma proposta contratual, sendo esta uma responsabilidade do comercializador, que entrará em contacto consigo.
          </DisclaimerText>
          <DisclaimerText>
            <ListBall />
            O OLMC não pode ser responsabilizado por eventuais diferenças no valor de faturação e/ou consumos de eletricidade e gás natural que venham a ocorrer durante este período, nem por eventuais divergências entre as partes que possam decorrer do contrato celebrado na sequência de informação disponibilizada pelo Portal Poupa Energia.
          </DisclaimerText>
          <DisclaimerTitle>
            Em caso de dúvida contacte-nos através do 211 160 500.
          </DisclaimerTitle>
        </Disclaimer>}

        {!this.state.canSub &&
          <Disclaimer>
            <DisclaimerTitle>Esclarecimentos</DisclaimerTitle>
            <DisclaimerText>
              De acordo com a legislação em vigor não é possível aos consumidores do mercado liberalizado regressarem ao mercado regulado, motivo pelo qual não pode aderir a este tarifário.
            </DisclaimerText>
            <DisclaimerTitle>
              Em caso de dúvida ou necessidade de esclarecimento adicional, <br />
              contacte-nos através do 211 160 500.
            </DisclaimerTitle>
          </Disclaimer>
        }

        {!this.props.adhesionResponse &&
          this.state.showedDisclaimer &&
          this.state.canSub &&
          !this.props.tariffInfo &&
          <Placeholder>
            <CenteredLoading />
          </Placeholder>}

      </ScrollModal>
    )
  }
}

export default Logic(TariffSubscribeModal)

const ErrorModal = styled(Modal)`
  > div:last-child {
    height: 100%;

    > div:first-child {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding-bottom: 50px;
    }
  }
`

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  align-items: center;
  justify-content: center;

  img {
    width: 87px;
    height: 64px;
    margin-bottom: 50px;
  }
`

const SuccessTitle = styled.h3`
  color: #010101;
  font-family: Nunito;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
  margin-bottom: 16px;
  text-transform: uppercase;
`

const SuccessInfo = styled.div`
  color: #010101;
  font-family: Nunito;
  font-size: 14px;
  line-height: 20px;
`

const ScrollModal = styled(Modal)`
  overflow: auto;
  padding-bottom: 100px;
  height: initial;
  bottom: 0;
  text-align: initial;
`

const Disclaimer = styled.div`
  padding: 20px 0;
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  color: #8abb3f;
`

const DisclaimerText = styled.div`
  margin-bottom: 10px;

  ${({ red }) => red && `
  color: indianred;
  `}
`

const ListBall = styled.div`
  width: 10px;
  height: 10px;
  background: linear-gradient(270deg,#006736 0%,#93C13E 100%);
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
`

const Placeholder = styled.div`
  height: 350px;
`

const CenteredLoading = styled(Loading)`
  min-height: initial;
`



// WEBPACK FOOTER //
// ./src/containers/TariffSubscribeModal/index.js